import api from './api'

export interface EmailLog {
  id: string
  recipient: string
  template: string | null
  subject: string | null
  status: 'sent' | 'failed'
  messageId: string | null
  error: string | null
  tenantId: string | null
  createdAt: string
  deliveryStatus: 'delivered' | 'bounced' | 'complaint' | null
  deliveryDetail: string | null
  deliveredAt: string | null
}

export interface JobCounts {
  waiting?: number
  active?: number
  completed?: number
  failed?: number
  delayed?: number
  [k: string]: number | undefined
}

export interface EmailMonitor {
  stats: { sent24h: string; failed24h: string; sent7d: string; failed7d: string; delivered7d?: string; bounced7d?: string; complaint7d?: string }
  byTemplate: Array<{ template: string | null; sent: string; failed: string }>
  queues: { email: JobCounts; notification: JobCounts }
}

export async function getEmailMonitor(): Promise<EmailMonitor> {
  const res = await api.get('/master/email-monitor')
  return res.data
}

export async function getEmailLogs(params?: {
  limit?: number
  offset?: number
  status?: string
  template?: string
}): Promise<{ logs: EmailLog[]; total: number }> {
  const q = new URLSearchParams()
  if (params?.limit) q.set('limit', String(params.limit))
  if (params?.offset) q.set('offset', String(params.offset))
  if (params?.status && params.status !== 'all') q.set('status', params.status)
  if (params?.template && params.template !== 'all') q.set('template', params.template)
  const res = await api.get(`/master/email-logs?${q.toString()}`)
  return res.data
}
